import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../../../services/common/http/common.http.service';
import { formatDate } from '../../../utils/utility-functions';

@Component({
  selector: 'app-pedidos-layout',
  templateUrl: './pedidos-layout.component.html',
  styleUrls: ['./pedidos-layout.component.scss'],
})
export class PedidosLayoutComponent implements OnInit {
  tableData: any[] = [];
  expandirCardsMobile: boolean = false;
  loader: boolean = false;

  constructor(private httpService: HttpService, private router: Router) {
    this.getPedidos();
  }

  ngOnInit() {}

  pesquisaParams = {
    TxPesquisar: '',
    IdPedido: '',
    DtPedido: '',
    IsExport: false,
    Pagina: 0,
    TamanhoPagina: 8,
    MaxPages: 1,
  };

  tableColumns = [
    { header: 'Nº do Pedido', key: 'numeroPedido', type: 'text' },
    { header: 'Fornecedor', key: 'fornecedor', type: 'text', default: true },
    { header: 'Item', key: 'item', type: 'text' },
    { header: 'Preço Kg', key: 'precoKg', type: 'text' },
    { header: 'Quantidade', key: 'quantidade', type: 'text' },
    { header: 'Data do Pedido', key: 'dataPedido', type: 'text' },
    { header: 'Valor Total', key: 'valorTotal', type: 'text' },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Editar',
          img: 'assets/images/visualizar.svg',
          action: (item: any) => this.viewItem(item),
          condition: (item: any) => true,
        },
      ],
    },
  ];

  rowsMobile = [
    {
      header: 'Nº do Pedido',
      key: 'numeroPedido',
      type: 'text',
      default: true,
    },
    { header: 'Fornecedor', key: 'fornecedor', type: 'text', default: true },
    { header: 'Item', key: 'item', type: 'text' },
    { header: 'Preço Kg', key: 'precoKg', type: 'text' },
    { header: 'Quantidade', key: 'quantidade', type: 'text' },
    { header: 'Data do pedido', key: 'dataPedido', type: 'text' },
    {
      header: 'Valor Total',
      key: 'valorTotal',
      type: 'text',
      default: true,
    },
    {
      header: 'Ações',
      key: 'acoes',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          img: 'assets/images/eye-blue.svg',
          action: (item: any) => this.viewItem(item),
          condition: (item: any) => true,
        },
      ],
    },
  ];

  getPedidos() {
    this.loader = true;
    const params = this.pesquisaParams;
    this.httpService.useGet('PedidoByFilter', params).subscribe({
      next: (res: any) => {
        if (!res.DataSet) {
          this.tableData = [];
          return;
        }
        this.tableData = res.DataSet.map((item: any) => {
          return {
            numeroPedido: item.IdPedido,
            fornecedor: item.NmFornecedor,
            item: item.NmMaterial,
            precoKg: item.QtPrecoKg.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
            quantidade: item.QtPedido,
            dataPedido: formatDate(item.DtPedido),
            valorTotal: item.VlTotal.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          };
        });
        this.pesquisaParams.MaxPages =
          Math.ceil(res.Total / this.pesquisaParams.TamanhoPagina) || 1;
      },
      error: (err: any) => {},
      complete: () => {
        this.loader = false;
      },
    });
  }

  editItem(item: any) {}

  viewItem(item: any) {
    const params = {
      ...item,
      isViewing: true,
    };
    this.router.navigate(['suprimentos/cadastrar-pedido'], {
      queryParams: params,
    });
  }

  exportExcel() {
    this.pesquisaParams.IsExport = true;
    this.getPedidos();
    this.pesquisaParams.IsExport = false;
  }

  timer: ReturnType<typeof setTimeout> | null = null;
  onChangeSearch() {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      this.getPedidos();
    }, 800);
  }

  mudarPagina(pagina: number) {
    this.pesquisaParams.Pagina = pagina;
    this.getPedidos();
  }

  navigateCriarPedido() {
    this.router.navigate(['suprimentos/cadastrar-pedido']);
  }
}
